import absorbers from "./absorbers.json";
import amongUs from "./amongUs.json";
import background from "./background.json";
import big from "./big.json";
import bubble from "./bubble.json";
import chars from "./chars.json";
import collisions from "./collisions.json";
import confetti from "./confetti.json";
import connect from "./connect.json";
import defaultAnim from "./default.json";
import divRepulse from "./divRepulse.json";
import emmiterAbsorber from "./emitterAbsorber.json";
import emitters from "./emitters.json";
import fontawesome from "./fontawesome.json";
import growing from "./growing.json";
import hollowknight from "./hollowknight.json";
import images from "./images.json";
import multiplePolygonMasks from "./multiplePolygonMasks.json";
import nasa from "./nasa.json";
import noconfig from "./noconfig.json";
import nyancat from "./nyancat.json";
import nyancat2 from "./nyancat2.json";
import parallax from "./parallax.json";
import polygonMask from "./polygonMask.json";
import polygons from "./polygons.json";
import preset from "./preset.json";
import random from "./random.json";
import shadow from "./shadow.json";
import slow from "./slow.json";
import snow from "./snow.json";
import star from "./star.json";
import trail from "./trail.json";
import twinkle from "./twinkle.json";
import virus from "./virus.json";
import warp from "./warp.json";

const ANIMATION_PRESETS = {
  "absorbers": absorbers,
  "amongUs": amongUs,
  "background": background,
  "big": big,
  "bubble": bubble,
  "chars": chars,
  "collisions": collisions,
  "confetti": confetti,
  "connect": connect,
  "defaultAnim": defaultAnim,
  "divRepulse": divRepulse,
  "emmiterAbsorber": emmiterAbsorber,
  "emitters": emitters,
  "fontawesome": fontawesome,
  "growing": growing,
  "hollowknight": hollowknight,
  "images": images,
  "multiplePolygonMasks": multiplePolygonMasks,
  "nasa": nasa,
  "noconfig": noconfig,
  "nyancat": nyancat,
  "nyancat2": nyancat2,
  "parallax": parallax,
  "polygonMask": polygonMask,
  "polygons": polygons,
  "preset": preset,
  "random": random,
  "shadow": shadow,
  "slow": slow,
  "snow": snow,
  "star": star,
  "trail": trail,
  "twinkle": twinkle,
  "virus": virus,
  "warp": warp
};

export default ANIMATION_PRESETS;